<template>
  <div>
    <a-form
      class="simiot-nested-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col :xl="8" :xxl="6">
          <a-form-item label="客户名称">
            <a-input
              v-decorator="['agent_name', { normalize: this.$lodash.trim }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col v-if="showSaleField" :xl="8" :xxl="6">
          <a-form-item label="责任销售">
            <a-select
              v-decorator="['sale_user_id']"
              show-search
              :filter-option="filterSaleOption"
              :loading="loadingSaleOptions"
              allow-clear
              @focus="fetchSaleOptions"
            >
              <a-select-option
                v-for="u in saleOptions"
                :key="u.id"
                :value="u.id"
              >
                {{ u.full_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="订单月份">
            <a-month-picker
              v-decorator="['order_month']"
              style="width: 100%;"
              placeholder="请选择月份"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="订单类型">
            <a-select
              v-decorator="['order_type']"
              :loading="loadingOrderTypeOptions"
              allow-clear
              @focus="fetchOrderTypeOptions"
            >
              <a-select-option
                v-for="o in orderTypeOptions"
                :key="o.value"
                :value="o.value"
              >
                {{ o.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="24" :xxl="12">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findSaleOptions } from '@/api/user'
import { findOrderSummaryFinanceOrderTypeOptions } from '@/api/order_summary'

export default {
  name: 'SearchCommissionOrders',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'order_summary_commission_search' }),
      orderTypeOptions: [],
      saleOptions: [],
      loadingOrderTypeOptions: false,
      loadingSaleOptions: false
    }
  },
  computed: {
    showSaleField() {
      return this.$store.getters.userRole !== 'sale'
    }
  },
  methods: {
    filterSaleOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    fetchOrderTypeOptions() {
      if (this.orderTypeOptions.length > 0) {
        return
      }
      this.loadingOrderTypeOptions = true
      findOrderSummaryFinanceOrderTypeOptions().then((res) => {
        if (res.code === 0 && res.data) {
          this.orderTypeOptions = res.data
        }
        this.loadingOrderTypeOptions = false
      }).catch(() => {
        this.loadingOrderTypeOptions = false
      })
    },

    fetchSaleOptions() {
      if (this.saleOptions.length > 0) {
        return
      }
      this.loadingSaleOptions = true
      findSaleOptions().then((res) => {
        if (res.code === 0) {
          this.saleOptions = res.data
        }
        this.loadingSaleOptions = false
      }).catch(() => {
        this.loadingSaleOptions = false
      })
    },

    buildQuery(values) {
      const q = { ...values }
      if (q.order_month && q.order_month.format) {
        q.order_month = q.order_month.format('YYYY-MM')
      }
      return q
    },

    handleSearch(e) {
      e.preventDefault()
      const values = this.form.getFieldsValue()
      this.$emit('submit', this.buildQuery(values))
    },

    handleReset() {
      this.orderTypeOptions = []
      this.saleOptions = []
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>

